var customScroll = require('./custom-scroll-engagement-handler');

function init() {
    customScroll.init($('.modal-drawer:not(.no-adhesion-overlap) .modal-content'));
}

init();

module.exports = {
    init: init
};



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/scroll-engagement-handler/drawer-scroll-engagement-handler.js
// module id = 134
// module chunks = 36